var React = require('react');

function AboriginalFlagInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4674_25152)","key":0},[React.createElement("path",{"d":"M0.316406 0H20.3164V12H0.316406V0Z","fill":"black","key":0}),React.createElement("path",{"d":"M0.316406 6H20.3164V12H0.316406V6Z","fill":"#CC0000","key":1}),React.createElement("path",{"d":"M10.3164 9C11.9733 9 13.3164 7.65685 13.3164 6C13.3164 4.34315 11.9733 3 10.3164 3C8.65955 3 7.31641 4.34315 7.31641 6C7.31641 7.65685 8.65955 9 10.3164 9Z","fill":"#FFFF00","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4674_25152"},React.createElement("rect",{"width":"20","height":"12","fill":"white","transform":"translate(0.316406)"})))]);
}

AboriginalFlagInline.defaultProps = {"width":"21","height":"12","viewBox":"0 0 21 12","fill":"none"};

module.exports = AboriginalFlagInline;

AboriginalFlagInline.default = AboriginalFlagInline;
